module.exports = __webpack_public_path__ + "img/impiantodefault.3d12abdb.png";